import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const routeMeta = {
  "/": {
    title: "Restoration.Roofing.Remodeling | Top Roofing Company Houston TX",
    description:
      "Looking for the best roofers in Houston or Spring, TX? Our local roofing contractors deliver residential and commercial roofing with quality workmanship.",
    robots: "index,follow",
  },
  "/home": {
    title: "Restoration.Roofing.Remodeling | Top Roofing Company Houston TX",
    description:
      "Looking for the best roofers in Houston or Spring, TX? Our local roofing contractors deliver residential and commercial roofing with quality workmanship.",
  },
  "/about-us": {
    title: "About Us | Restoration.Roofing.Remodeling",
    description:
      "Learn about Restoration Roofing & Remodeling, a trusted Houston and Spring, TX roofing and remodeling company delivering quality craftsmanship and reliable service.",
  },
  "/roofing-service": {
    title: "Best Roof Installation Houston | Residential & Commercial Roof Install Spring TX",
    description:
      "Need roof installation or replacement in Houston or Spring, TX? We provide residential, commercial, and emergency roofing with quality craftsmanship.",
  },
  "/storm-service": {
    title: "Storm Damage Roof Restoration Services Spring TX | Wind Damage Roof Repair Houston",
    description:
      "Need storm damage roof repair or restoration in Houston or Spring, TX? We provide hail and wind damage roof repair services throughout Houston and Spring.",
  },
  "/roofing-company": {
    title: "Professional Roofing Company in Texas | Reliable Roofers",
    description:
      "Work with a trusted roofing company in Texas for roof repair, replacement, inspections, and roof restoration projects.",
  },
  "/roof-repair": {
    title: "Residential Roof Repair Services Spring TX | Roof Leak Repair Houston",
    description:
      "Need emergency roof repair in Houston or Spring, TX? We provide residential roof repair and roof leak repair services with fast, reliable solutions.",
  },
  "/roof-inspection": {
    title: "Professional Roof Inspection Services | Residential Roof Inspection Houston, Spring TX",
    description:
      "Need a roof inspection in Houston or Spring, TX? Our professional roof inspection services help protect your home with detailed residential roof inspections.",
  },
  "/roof-restoration": {
    title: "Restoration Roofing Specialist | Roof Restoration Company",
    description:
      "Restore your roof with our trusted roof restoration company. Our restoration roofing specialists deliver expert solutions that protect and extend roof life.",
  },
  "/remodeling-company": {
    title: "Residential Remodeling Company Houston | Home Remodeling Contractor Spring TX",
    description:
      "Looking for a trusted home remodeling contractor in Houston or Spring, TX? Our residential remodeling company specializes in quality home and residential remodeling.",
  },
  "/kitchen-remodeling": {
    title: "Professional Kitchen Remodeling Services | Kitchen Remodel Contractor Houston, Spring TX",
    description:
      "Looking for the professional kitchen renovation services in Houston or Spring, TX? Our kitchen remodel contractors deliver beautiful kitchen remodels and renovations built to last.",
  },
  "/bedroom-remodeling": {
    title: "Bathroom Remodeling Contractor Houston TX | Bathroom Remodeling Company Spring TX",
    description:
      "Looking for a trusted bathroom remodeling company in Houston or Spring, TX? Our bathroom remodeling contractors deliver beautiful bathroom remodels and renovations built to last.",
  },
  "/bathroom-remodeling": {
    title: "Bathroom Remodeling Contractor Houston TX | Bathroom Remodeling Company Spring TX",
    description:
      "Looking for a trusted bathroom remodeling company in Houston or Spring, TX? Our bathroom remodeling contractors deliver beautiful bathroom remodels and renovations built to last.",
  },
  "/contact-us": {
    title: "Contact Us | Restoration.Roofing.Remodeling",
    description:
      "Contact Restoration Roofing & Remodeling in Spring, TX for a free estimate. Call our team for roofing, restoration, and remodeling services.",
  },
  "/financing": {
    title: "Houston Roofers With Financing | Restoration.Roofing.Remodeling",
    description:
      "Need Houston roofers with financing? We offers flexible financing options for residential and commercial roofing projects.",
  },
  "/videos": {
    title: "Roofing & Remodeling Videos | Restoration Roofing & Remodeling",
    description:
      "Watch roofing, storm restoration, and remodeling videos from Restoration Roofing & Remodeling.",
  },
  "/roofing": {
    title: "Shingle Roofing Installation Houston | Install Shingles On Roof",
    description:
      "Need roof shingle installation in Houston or Spring, TX? Our shingle experts install shingles on roofs with precision, delivering durable, high-quality roofing solutions.",
  },
  "/roofing-shingles": {
    title: "Shingle Roofing Installation Houston | Install Shingles On Roof",
    description:
      "Need roof shingle installation in Houston or Spring, TX? Our shingle experts install shingles on roofs with precision, delivering durable, high-quality roofing solutions.",
  },
  "/commercial": {
    title: "Commercial Roofing Services in Texas",
    description:
      "Reliable commercial roofing services for offices, retail spaces, and other commercial properties in Texas.",
  },
  "/lifetime-shingles": {
    title: "Lifetime Shingles | Premium Roofing Products",
    description:
      "Explore premium lifetime shingles and long-lasting roofing materials for durable, high-performance roofs.",
  },
  "/virtual-remodeling": {
    title: "Virtual Remodeling Services | Design Your Space Online",
    description:
      "Use our virtual remodeling tools to plan your next home improvement project with confidence.",
  },
  "/warranty": {
    title: "Roofing Warranty Information | Restoration Roofing & Remodeling",
    description:
      "Learn about roofing warranties, coverage details, and protection options for our roofing and remodeling services.",
    robots: "index,follow",
  },
  "/404.html": {
    title: "404 Page Not Found | Restoration Roofing & Remodeling",
    description:
      "The requested page could not be found. Explore our roofing, storm repair, and remodeling services in Texas.",
    robots: "noindex,nofollow",
  },
  "/new-roof": {
    title: "New Roof Installation Services in Texas",
    description:
      "Get expert new roof installation with durable materials, professional craftsmanship, and dependable warranties.",
  },
  "/roof-system": {
    title: "Roofing Systems & Materials | Expert Guidance",
    description:
      "Explore roofing systems and material options to find the best fit for your home or commercial property.",
  },
  "/attic-vent": {
    title: "Attic Ventilation Solutions | Improve Roof Performance",
    description:
      "Improve attic airflow and roof performance with professional attic ventilation solutions.",
  },
  default: {
    title: "Restoration Roofing & Remodeling | Roofing & Remodeling Experts",
    description:
      "Restoration Roofing & Remodeling provides trusted roofing, storm repair, and remodeling services across Texas.",
    robots: "index,follow",
  },
};

export default function RouteMeta() {
  const location = useLocation();
  const pathname = location.pathname.replace(/\/+$/, "") || "/";
  const currentRoute = routeMeta[pathname] || routeMeta.default;
  const canonicalPath = pathname === "/" ? "/" : `${pathname}/`;
  const canonicalUrl = `https://restorationroofingremodeling.com${canonicalPath}`;

  return (
    <Helmet>
      <title>{currentRoute.title}</title>
      <meta name="description" content={currentRoute.description} />
      <meta name="robots" content={currentRoute.robots || "index,follow"} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:title" content={currentRoute.title} />
      <meta property="og:description" content={currentRoute.description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta name="twitter:title" content={currentRoute.title} />
      <meta name="twitter:description" content={currentRoute.description} />
      <meta name="twitter:url" content={canonicalUrl} />
    </Helmet>
  );
}
